import React, { createContext, useCallback, useContext, useState } from 'react'
import { translations } from './translations'

const languages = {
  en: 'In English',
  fi: 'Suomeksi',
}

function getBrowserLang() {
  if (!navigator.language) return
  const [browserLang] = navigator.language.split('-')
  return languages[browserLang] ? browserLang : undefined
}

const TranslatorContext = createContext({
  t: str => str,
  lang: getBrowserLang(),
  languages,
  setLang: () => {},
})

export function TranslatorProvider({ children }) {
  const [lang, setLang] = useState(getBrowserLang())

  const t = useCallback(
    key => {
      const trans = translations[lang]
      return trans[key] || key
    },
    [lang]
  )

  const contextValue = {
    lang,
    setLang,
    languages,
    t,
  }

  return <TranslatorContext.Provider value={contextValue}>{children}</TranslatorContext.Provider>
}

export function useTranslator() {
  return useContext(TranslatorContext)
}
